// @flow
import React, { Component } from 'react';

import './PagePartner.css';

import FooterSocial from 'components/footer/FooterSocial';
import PageNodeHeader from 'containers/page/PageNodeHeaderContainer';
import PagePartenaireHeader from 'containers/page/PagePartenaireHeaderContainer';
import SubRouter from 'components/subRouter/SubRouter';
import Sidebar from 'components/sidebar/Sidebar';
import ContentBloc from 'components/newsletter/blocs/ContentBloc';
import PageNotFound from 'components/app/PageNotFound';
import PagePratiques from 'components/page/template/PagePratiques';
import PageEntrainements from 'components/page/template/PageEntrainements';
import Loading from 'components/fragments/Loading';
import { handleTagEvent } from 'utils/tagManagerUtils';
import { STATUS_UNKNOWN, STATUS_LOADING, STATUS_SUCCESS, STATUS_FAILURE } from 'constants/statusConstants';
import { nullPageNode } from 'types/PageNode';

import type { Match } from 'react-router-dom';
import type { Status } from 'types/Status';
import type { BlocContent } from 'types/NewsletterBloc';
import type { PageChildType } from 'types/PageNode';
import type { PartenaireType } from 'types/Partenaires';
// import

export type OwnProps = {
  location: {
    pathname: string,
    search: string,
  }
};

export type DispatchProps = {
  fetchPageNode: (slug: string) => void,
  fetchPageList: (slug: string) => void,
  fetchPartenaire: (slug: string) => void,
  fetchPageDetailPreview: (id: number) => void,
};

export type StateProps = {
  contentNode: BlocContent[],
  liste_enfants: PageChildType[],
  sidebar_content: BlocContent[],
  pageDetailSidebar:BlocContent[],
  pageListSidebar: BlocContent[],
  status: Status,
  statusList: Status,
  statusPreview: Status,
  statusPartner: Status,
  template: string,
  templateDetail: string,
  templateList: string,
  redirection: string,
  partenaire: PartenaireType,
  preview: any,
  organization: string,
  pratiques_structure: any[],
  club: string,
};

type HistoryProps = {
  history: any
};

type Props = {
  pageSlug: string,
  match: Match
} & OwnProps & DispatchProps &
  StateProps & HistoryProps;

type State = {
  currentPage: string,
  failedLoading: boolean
};

class PageNode extends Component<Props, State> {
  state: State = {
    currentPage: '',
    failedLoading: false,
  };
  componentDidMount() {
    const {
      fetchPageNode,
      fetchPageDetailPreview,
      pageSlug,
      match: {
        params : {
          slugNode
        }
      }
    } = this.props;

    const splits = this.props.location.pathname.split('/');
    if (/page_/.test( splits[splits.length - 1])) {
      const id = splits[splits.length - 1].replace('page_', '');
      fetchPageDetailPreview(parseInt(id, 10));
    } else {
      if (slugNode) {
        fetchPageNode(slugNode);
      } else {
        fetchPageNode(pageSlug);
      }
    }
    
    this.setState({currentPage: 'ok'});
  }

  componentDidUpdate(prevProps: Props) {
    const { fetchPageList, match: { params: { slug, slugNode } } } = this.props;
    /**
     * Si on a un statut en erreur, on va récupérer les infos de la page parente
     */
    if (prevProps.status !== this.props.status && 
      (this.props.status === STATUS_UNKNOWN || this.props.status === STATUS_FAILURE) && 
      slug) {
      fetchPageList(slug);
    } else if (this.props.statusList === STATUS_FAILURE || this.props.statusPreview === STATUS_FAILURE) {
      this.setState({failedLoading: true});
    } else if (prevProps.statusList !== this.props.statusList &&
      (this.props.statusList !== STATUS_UNKNOWN && this.props.statusList !== STATUS_LOADING)) {
      /**
       * Si la page parente est récupérée
       */
      if (this.props.statusList === STATUS_SUCCESS) {
        if (this.props.templateList === 'partenaires') {
          const { fetchPartenaire, statusPartner} = this.props;
          if (statusPartner === STATUS_FAILURE) {
            this.setState({failedLoading: true});
          } else {
            if (slugNode) {
              fetchPartenaire(slugNode.replace('--partenaire', ''));
            } else {
              this.setState({failedLoading: true});
            }
          }
        } else {
          if (slugNode && slugNode.match(/--partenaire/)) {
            const { fetchPartenaire, statusPartner } = this.props;
            if (statusPartner === STATUS_FAILURE) {
              this.setState({failedLoading: true});
            } else {
              fetchPartenaire(slugNode.replace('--partenaire', ''));
            }
          } else {
            /**
             * Nous ne sommes pas sur un partenaire => erreur
             */
            this.setState({failedLoading: true});
          }
        }
      } else {
        /**
         * On n'arrive pas à charger la page liste parente => erreur
         */
        this.setState({failedLoading: true});
      }
    } else if (prevProps.statusPartner !== this.props.statusPartner && (this.props.statusPartner === STATUS_FAILURE)){
      this.setState({failedLoading: true});
    } else if (prevProps.statusPreview !== this.props.statusPreview && (this.props.statusPreview === STATUS_FAILURE)){
      this.setState({failedLoading: true});
    }
  }

  shouldComponentUpdate(nextProps: Props, nextState: State) {
    const {
      match: {
        params,
      },
      location: {
        search,
      },
    } = this.props;
    const {
      match: {
        params: nextParams,
        },
      location: {
        search: nextSearch,
        }
      } = nextProps;
    const { liste_enfants, fetchPageNode } = this.props;
    if (nextState.failedLoading !== this.state.failedLoading) {
      return true;
    }
    if (nextProps !== this.props) {
      if (nextParams.slugNode) {
        if (nextParams.slugNode !== params.slugNode) {
          fetchPageNode(nextParams.slugNode);
          return liste_enfants !== nextProps.liste_enfants;
        }
      }
      if (nextSearch !== search) {
        return false;
      }

      return true;
    }
    return false;
  }

  renderSubRouter = () => {
    const { liste_enfants, contentNode, match } = this.props;

    if (JSON.stringify(liste_enfants) !== JSON.stringify(nullPageNode.liste_enfants)) {
      return <SubRouter subroutes={liste_enfants} match={match} />;
    }

    return (
      <div className="page">
        {contentNode.map((blocFigure, index) => {
          return (
            <ContentBloc key={index} {...blocFigure} />
          );
        })}
      </div>
    );
  };

  renderPageNodeHeader = (withTab: boolean = true) => {
    const { liste_enfants, location } = this.props;
    let className = '';

    if (JSON.stringify(liste_enfants) !== JSON.stringify(nullPageNode.liste_enfants) && withTab) {
      const splits = location.pathname.split('/');
      /**
       * Si on est sur une page de prévisu, on ajoute un onglet prévisualisation
       */
      if (liste_enfants.filter(function(e) {return e.type_name === "page_previsu";}).length === 0
        && /page_/.test( splits[splits.length - 1])) {
        const idNum = splits[splits.length - 1].replace('page_', '');
        const previewPage = {
            menu_order:0,
            object_id: parseInt(idNum, 10),
            type_name: 'page_previsu',
            object_slug: splits[splits.length - 1],
            title: 'prévisualisation',
            description: '',
            featured_media: { src: '' },
            texte_cta: '',
            types_public: []
        };
        liste_enfants.push(previewPage);
      }
      return <PageNodeHeader withSubMenu={true} className={className} />;
    }

    return <PageNodeHeader withSubMenu={false} className={className} />;
  };

  renderSidebar = () => {
    const { sidebar_content, pageDetailSidebar } = this.props;
    let sidebarContent;

    if (pageDetailSidebar.length > 0) {
      sidebarContent = pageDetailSidebar;
    } else {
      sidebarContent = sidebar_content;
    }

    return <Sidebar sidebarContent={sidebarContent} />;
  };

  _renderContent = () => {
    const { renderSubRouter, renderSidebar } = this;

    return (
      <div className="row">
        <div className="col col-md-8 col-lg-9 bg-overflow">
          <section>
            <div className="row">
              <div className="col col-lg-8on9">{renderSubRouter()}</div>
            </div>
          </section>
        </div>
        {renderSidebar()}
      </div>
    );
  };

  clickTagManager = (socialName: string) => {
    const { partenaire: { title }, club } = this.props;
    return handleTagEvent(
      'partage',
      `partage_${title}`,
      club,
      () => {},
      socialName
    );
  };

  _renderContentPartenaire = () => {
    const { pageListSidebar, partenaire } = this.props;
    let sidebarContent;
    if (partenaire.sidebar && partenaire.sidebar.length > 0) {
      sidebarContent = partenaire.sidebar;
    } else {
      sidebarContent = pageListSidebar;
    }

    return (
      <>
      <div className="col col-md-8 col-lg-9 bg-overflow">
        <section>
          <PagePartenaireHeader />
          <div className="row">
            <div className="col col-lg-8on9">
              <article className="article clearfix">
                <section>
                  <div className="row">
                    <div className="col col-lg-9on9">
                      <div className="bb1">
                        {partenaire.featured_media.src &&
                        <div className="block-partner block-partner--detail mt-2 mb-4">
                          <div className="block-partner__left">
                            <img src={partenaire.featured_media.src} alt="" />
                          </div>
                        </div>}
                        {(partenaire.facebook ||
                          partenaire.twitter ||
                          partenaire.instagram ||
                          partenaire.youtube ||
                          partenaire.lien) &&
                        <div className="liens-structure mb-3" style={
                          { display: 'flex', justifyContent: 'space-between'}
                        }>
                          <div className="social">
                            {partenaire.facebook && (
                              <a
                                href={partenaire.facebook}
                                title="Facebook"
                                target="_blank"
                                rel="noopener noreferrer">
                                <span className="label label--blue label--icon">
                                  <i className="icon icon-facebook"></i>
                                </span>&nbsp;&nbsp;
                              </a>
                            )}
                            {partenaire.twitter && (
                              <a
                                href={partenaire.twitter}
                                title="Twitter"
                                target="_blank"
                                rel="noopener noreferrer">
                                <span className="label label--blue label--icon is-dark">
                                  <i className="icon icon-twitter"></i>
                                </span>&nbsp;&nbsp;
                              </a>
                            )}
                            {partenaire.instagram && (
                              <a
                                href={partenaire.instagram}
                                title="Youtube"
                                target="_blank"
                                rel="noopener noreferrer">
                                <span className="label label--blue label--icon">
                                  <i className="icon icon-instagram"></i>
                                </span>&nbsp;&nbsp;
                              </a>
                            )}
                            {partenaire.youtube && (
                              <a
                                href={partenaire.instagram}
                                title="Instagram"
                                target="_blank"
                                rel="noopener noreferrer">
                                <span className="label label--blue label--icon">
                                  <i className="icon icon-youtube"></i>
                                </span>&nbsp;&nbsp;
                              </a>
                            )}
                            {partenaire.linkedin && (
                              <a
                                href={partenaire.linkedin}
                                title="Linkedin"
                                target="_blank"
                                rel="noopener noreferrer">
                                <span className="label label--blue label--icon">
                                  <i className="icon icon-linkedin"></i>
                                </span>&nbsp;&nbsp;
                              </a>
                            )}
                          </div>
                          <div className="lien ft-700">
                            {partenaire.lien &&
                              <>
                                <a href={partenaire.lien} target="_blank" rel="noopener noreferrer">
                                  {partenaire.lien_cta ? partenaire.lien_cta : 'Accéder au site'}
                                </a><span>&nbsp;&nbsp;<i className="icon icon-external"></i></span>
                              </>
                            }
                          </div>
                        </div>
                        }
                      </div>
                      <div className="page">
                        {partenaire.content.data.map((blocFigure, index) => {
                          return (
                            <ContentBloc key={index} {...blocFigure} />
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </section>
              </article>
              <FooterSocial
                  url={window.location.href}
                  title={partenaire.title || ''}
                  titleclass="mt-md-3 mt-lg-5 mb-3"
                  clickTagManager={(socialName) => this.clickTagManager(socialName)} />
            </div>
          </div>
        </section>
      </div>
      <Sidebar sidebarContent={sidebarContent} />
      </>
    );
  };

  render() {
    const { status, statusPreview, template, partenaire, match: {params: {slugNode}} } = this.props;
    const { failedLoading } = this.state;
    const withTab = template !== 'pratiques';

    if (partenaire && partenaire.id > 0 && slugNode && slugNode.match(/--partenaire/)) {
      return (
        <>
          <div className="container">
            <div className="row">
              {this._renderContentPartenaire()}
            </div>
          </div>
        </>
      );
    }
  
    if (failedLoading) {
      return <PageNotFound noMargin />;
    }
    
    if (this.state.currentPage && status === STATUS_SUCCESS) {
      switch (template) {
        case 'pratiques':
          return (
            <>
              {this.renderPageNodeHeader(withTab)}
              <div className="container">
                <PagePratiques {...this.props} />
              </div>
            </>
          );
        case 'page-entrainement':
          return (
            <>
              {this.renderPageNodeHeader(withTab)}
              <div className="container">
                <PageEntrainements {...this.props} />
              </div>
            </>
          );
        default:
          return (
            <>
              {this.renderPageNodeHeader(withTab)}
              <div className="container">
                  {this._renderContent()}
              </div>
            </>
          );
      }
    } else if (statusPreview === STATUS_SUCCESS) {
      return (
        <>
          {this.renderPageNodeHeader(withTab)}
          <div className="container">
              {this._renderContent()}
          </div>
        </>);
    }
    return <Loading />;
  }
}

export default PageNode;
